import { BidiModule } from "@angular/cdk/bidi";
import { OverlayModule } from "@angular/cdk/overlay";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { NzOutletModule } from "ng-zorro-antd/core/outlet";
import { UiDropdownMenuComponent } from "./components/dropdown-menu/dropdown-menu.component";
import { UiDropDownADirective } from "./directives/dropdown-a.directive";
import { UiDropdownButtonDirective } from "./directives/dropdown-button.directive";
import { UiDropDownDirective } from "./dropdown.directive";

@NgModule({
  imports: [CommonModule, BidiModule, OverlayModule, NzOutletModule],
  declarations: [UiDropDownDirective, UiDropDownADirective, UiDropdownMenuComponent, UiDropdownButtonDirective],
  exports: [UiDropDownDirective, UiDropDownADirective, UiDropdownMenuComponent, UiDropdownButtonDirective],
})
export class UiDropdownModule {}
